import type { GoalFormModel } from "web_myplann/Goals/Forms/useGoalForm";
import { GoalFormParam } from "web_myplann/Goals/Types/GoalFormParam";
import { RentDrawdownMode } from "web_myplann/Goals/Types/RentDrawdownMode";
import { GoalCategoryTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { getTypedParam } from "web_myplann/Shared/Utils/getTypedParam";
import { parseDate } from "web_myplann/Shared/Utils/parseDate";
import { parseEnumValue } from "web_myplann/Shared/Utils/parseEnumValue";

export const mapParamsToGoalForm = (
	params: URLSearchParams,
): Partial<GoalFormModel> => ({
	category: parseEnumValue(
		GoalCategoryTypeEnum,
		params.get(GoalFormParam.Category),
	),
	name: getTypedParam(params, GoalFormParam.Name, String),
	totalValue: getTypedParam(params, GoalFormParam.TotalValue, Number),
	ownFunds: getTypedParam(params, GoalFormParam.OwnFunds, Number),
	loanAmount: getTypedParam(params, GoalFormParam.LoanAmount, Number),
	monthlyRent: getTypedParam(params, GoalFormParam.MonthlyRent, Number),
	drawdownMode: parseEnumValue(
		RentDrawdownMode,
		params.get(GoalFormParam.DrawdownMode),
	),
	dueDate: parseDate(params.get(GoalFormParam.DueDate)),
});
